export const isBrowser = process.browser && typeof window !== 'undefined'

// check if it's airport app aka fbb
export const isFBB = isBrowser && window.location.hostname === 'fbb.pickpack.de'

export const getGlobalContext = () => {
  if (typeof window !== 'undefined') return window // browser
  return global // server-side rendering (node.js)
}
